import { getContainerClass } from "./container.styles";
import type { ContainerProps } from "./container.types";

export function Container({ className, ...props }: ContainerProps) {
  return <div className={getContainerClass({ className })} {...props} />;
}
